import { useTranslateDate as useTranslateDateCommon } from '@caudena/core/utils/date'
import { useSettings } from '../useSettings'

/**
 * IMPORTANT! Use inside mobx-react-lite observer!!!
 */
export const useTranslateDate = () => {
  const { settings } = useSettings()
  return useTranslateDateCommon(settings?.timeZone)
}
